import { CategoryKey, HoldToken } from '@seatsio/seatsio-react';

import { EventCardFragment } from './api/dato-operations.types';
import {
  BookObjectInfoFragment,
  MoneyInfoFragment,
  TicketFragment,
  TicketInfoFragment,
  TranslatedTextFragment,
} from './api/tickets.types';

export type EnhancedTicketInfo = Pick<
  TicketInfoFragment,
  'isAvailable' | 'paymentMethods'
> & {
  isSoldOut: boolean;
  originalPrice: MoneyInfoFragment | undefined;
  discountedPrice?: MoneyInfoFragment | undefined;
};

export type EnhancedTicketsEventCard = EventCardFragment & {
  ticketCount: number;
};

export type CartCoupon = {
  code: string | undefined;
  value: MoneyInfoFragment;
};

// Splits out the coupon codes in saudiRewards / coupon codes
export type SplitCartCoupon = {
  coupon: CartCoupon | undefined;
  saudiRewards: CartCoupon | undefined;
};

export enum QueryParam {
  ErrorState = 'error-state',
  Status = 'status',
}

export type Categories = Array<{
  id: string;
  name: string;
  categoryWithSubcategoryName: string;
  tickets: Array<TicketFragment>;
}>;

export type EventKey = string;

export type LocalCartItem = {
  catalogueItemId: string;
  name: TranslatedTextFragment;
  quantity: number;
  bookObjectsInfo?: Array<BookObjectInfoFragment>;
};

export type LocalCartItemPricing = LocalCartItem & {
  totalPrice: MoneyInfoFragment;
  subtotalPrice: MoneyInfoFragment;
};

export type SeatingToken = Pick<HoldToken, 'token' | 'expiresAt'> & {
  expired: boolean;
  expirationHandled: boolean;
};

export type SeatingInfo = {
  chartKey: string;
  focusCategoryKey: Array<CategoryKey>;
  categories: Array<SeatingCategory>;
  dateTimeRange: {
    start: string | undefined;
    end: string | undefined;
  };
};

export type SeatingCategory = {
  ticketId: TicketFragment['id'];
  name: TicketFragment['name'];
  categoryKey: string;
};

export const TICKET_FILTERS_ALL = 'all_tickets_included';
